var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHairQ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 150,
    viewBox: "0 0 128 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 149.24V119.128C0 95.9286 9.96717 74.5632 17.2134 71.1967C49.5 56.1966 77 56.1966 111.257 71.6282C120.224 75.6678 128 105.128 128 119.128V149.24C126.847 148.394 125.503 147.766 123.948 147.393C123.983 146.045 124 144.683 124 143.306C124 96.9238 104.169 72 64 72C23.8312 72 4 96.9238 4 143.306C4 144.683 4.01747 146.045 4.05241 147.393C2.49732 147.766 1.15329 148.394 0 149.24Z",
    className: "Hair"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.767 96.9789C127.476 79.2508 131.253 60.9224 122.905 44.7615C122.398 43.7802 121.124 43.4719 120.168 44.0242C117.389 45.6284 114.712 47.1746 112.135 48.667C113.278 36.2939 110.039 25.253 102.025 16.4522C101.281 15.6355 99.9714 15.6673 99.1904 16.4484C95.9593 19.6798 92.8967 22.744 89.9991 25.6548C87.3759 15.2103 81.6484 6.77525 72.714 1.04396C71.7843 0.447558 70.5273 0.817335 69.975 1.77394C45.0177 45.0047 34.3334 63.7627 37.8269 76.5588C45.3019 73.5373 54.0237 72 63.9998 72C87.5388 72 104.094 80.5587 113.767 96.9789Z",
    className: "Hair"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairQ);
export default __webpack_public_path__ + "static/media/Hair Q.3884f062b40526b9d2da6a0d0d496476.svg";
export { ForwardRef as ReactComponent };